import React, { useState } from 'react';
import Button from '../../../../../component/ui/Button';
import arrow from '../../../../../assets/image/arrowD.svg';
import checkIcon from '../../../../../assets/image/check_stock_icon.svg';
import search from '../../../../../assets/image/search-status.svg';
import useAccounts from './hooks/useAccounts';
import { ACCOUNTS_STATUS_LIST, capitalizeWords } from '../../../../../utils/constant';
import CreateAccountsModal from '../components/createAccountsModal';
import PageLoader from '../../../../../component/PageLoader';
import { hasPermission } from '../../../../../utils/controller';
import { useSelector } from 'react-redux';
import DataNotFound from '../../../../components/dataNotFound';
import Pagination from '../../../../../component/pagination';
import AccountsDetails from './accountsDetails';
import AccountListTable from '../components/accountListTable';
import CustomToastMessage from '../../../../components/customToastMessage';
import DeactivateConfirmAccountModal from '../components/deactivateConfirmAccountModal';
import DeleteAccountModel from '../components/deleteAccountModel';

export default function Accounts({ activeTab }) {
	const {
		setIsOpenAccountsModal,
		isOpenAccountsModal,
		params,
		setParams,
		setSearchText,
		searchText,
		sortDataList,
		sortDirection,
		setLoader,
		loader,
		accounts,
		isShowToast,
		showMessage,
		setIsOpenDeactivateConfirmAccountModal,
		isOpenDeactivateConfirmAccountModal,
		setIsOpenDeactivateAccountModal,
		isOpenDeactivateAccountModal,
		handleDeactivateAccount,
		setIsOpenActivateAccountModal,
		isOpenActivateAccountModal,
		handleActivateAccount,
		getAccountList,
	} = useAccounts();
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [type, setType] = useState('account-list');
	const [selectedAccountId, setSelectedAccountId] = useState(null);
	const onRowClick = (id) => {
		if (id && hasPermission('accounting.accounts.view', user?.role?.role_permissions)) {
			setSelectedAccountId(id);
			setType('account-details');
		}
	};
	const [isAccountOpenDropdown, setIsAccountOpenDropdown] = useState(false);
	const [isOpenDeleteAccountModal, setIsOpenDeleteAccountModal] = useState(false);

	const toggle = () => {
		setIsAccountOpenDropdown(!isAccountOpenDropdown);
	};

	const columns = [
		{ key: 'account_name', label: 'ACCOUNT NAME' },
		{ key: 'account_code', label: 'ACCOUNT CODE' },
		{ key: 'account_type', label: 'ACCOUNT TYPE' },
		{ key: 'category', label: 'CATEGORY' },
		{ key: 'description', label: 'USED FOR' },
		{ key: 'status', label: 'STATUS' },
		{ key: 'source', label: 'SOURCE' },
		{ key: 'action', label: 'ACTION' },
	];

	return (
		<div>
			{type === 'account-list' ? (
				<div>
					<div
						className="d-flex justify-content-between align-items-center sticky-top z-3 p-4"
						style={{ backgroundColor: '#EDEDF7' }}
					>
						<div>
							<div className="fs-3 fw-bold text-black">{activeTab}</div>
							<div
								className="fs-5 fw-light text-gray"
								style={{ color: '#718096' }}
							>
								{
									'Manage accounts used for recording sales, purchases, payments, expenses, stock, and other business transactions.'
								}
							</div>
						</div>
						<div className="d-flex gap-4 align-items-center">
							<Button
								type="button"
								button={'New Accounts'}
								disabled={false}
								className="btn btn-primary mt-0 px-2 fs-5 fw-light"
								add
								onClick={() => {
									setSelectedAccountId(null);
									setIsOpenAccountsModal(true);
								}}
							/>
							<Button
								type="button"
								button={'Import Accounts'}
								disabled={false}
								className="btn btn-gray mt-0 px-3 py-1 fs-5 fw-light"
								onClick={() => {}}
							/>
						</div>
					</div>
					<div className="d-flex px-3 py-4 gap-4">
						<div className="accounting-dropdown-container d-flex align-items-center">
							<div onClick={toggle}>
								<div className="d-flex align-items-center justify-content-between">
									<div className="accounting-dropdown fs-4 fw-semibold px-3 py-2">
										{params.status === '' || params.status === null
											? 'All Accounts'
											: capitalizeWords(params.status)}
										<span
											style={{
												transform: isAccountOpenDropdown ? 'rotate(180deg)' : 'rotate(0deg)',
											}}
										>
											<img
												src={arrow}
												alt=""
											/>
										</span>
									</div>
								</div>
								{isAccountOpenDropdown && (
									<div className="accounting-dropdown-options-container">
										{ACCOUNTS_STATUS_LIST.map((option) => (
											<div
												key={option.key}
												className="p-2 cursor-pointer"
												onClick={() => {
													setParams((prev) => ({
														...prev,
														status: option.key,
													}));
												}}
											>
												{option.label}
											</div>
										))}
									</div>
								)}
							</div>
						</div>
						<div className="accounting-search d-flex align-items-center rounded-3 shadow-sm p-2">
							<img
								src={search}
								alt="search-icon"
								width="18"
								height="18"
								className="rounded-circle me-2"
							/>
							<input
								type="text"
								placeholder="Search by account name or code"
								style={{ border: '0' }}
								autoComplete="off"
								autoFocus={true}
								value={searchText}
								id="search-id"
								name="search"
								onChange={(e) => setSearchText(e.target.value)}
								className={`fs-4 fw-light flex-1 bg-transparent outline-none border-0 border-0 shadow-none text-gray-700 placeholder-gray-400`}
							/>
						</div>
					</div>
					{loader ? (
						<PageLoader />
					) : accounts.data.length > 0 ? (
						<div className="productTable-body">
							<AccountListTable
								columns={columns}
								accountType={'accounts'}
								row={accounts.data}
								sortDataList={sortDataList}
								onRowClick={onRowClick}
								setAccountId={setSelectedAccountId}
								sortDirection={sortDirection}
								setIsOpenAccountsModal={setIsOpenAccountsModal}
								setIsOpenDeactivateConfirmAccountModal={setIsOpenDeactivateConfirmAccountModal}
								setIsOpenDeleteModal={setIsOpenDeleteAccountModal}
							/>
						</div>
					) : (
						<DataNotFound
							title={'No custom accounts added yet!'}
							subtitle={'Add a custom account only when you want to track'}
							content={'something separately.'}
							descriptionTitle={''}
							descriptionSubTitle={''}
							descriptionContent={''}
							buttonText={'Add New Account'}
							disabled={!hasPermission('accounting.accounts.create', user?.role?.role_permissions)}
							onClick={() => setIsOpenAccountsModal(true)}
						/>
					)}
					{accounts.data.length > 0 && (
						<Pagination
							PageFix={1}
							currentPage={params.page}
							totalPages={accounts.totalPages}
							onChangePage={(page) => {
								setParams((prev) => ({
									...prev,
									page: page,
								}));
							}}
							pageSize={params.page_size}
							setParam={(value) => {
								setParams((prev) => ({
									...prev,
									page_size: value,
									page: 1,
								}));
							}}
						/>
					)}
				</div>
			) : (
				<AccountsDetails
					setIsOpenAccountsModal={setIsOpenAccountsModal}
					accountId={selectedAccountId}
					setAccountId={setSelectedAccountId}
					setType={setType}
					setLoader={setLoader}
					loader={loader}
					setIsOpenActivateAccountModal={setIsOpenActivateAccountModal}
					setIsOpenDeactivateAccountModal={setIsOpenDeactivateAccountModal}
					isOpenDeactivateAccountModal={isOpenDeactivateAccountModal}
					isOpenActivateAccountModal={isOpenActivateAccountModal}
					handleActivateAccount={handleActivateAccount}
					showMessage={showMessage}
					isOpenAccountsModal={isOpenAccountsModal}
				/>
			)}

			{isOpenAccountsModal && (
				<CreateAccountsModal
					showMessage={showMessage}
					setSelectedId={setSelectedAccountId}
					selectedId={selectedAccountId}
					isOpenModal={isOpenAccountsModal}
					setIsOpenModal={setIsOpenAccountsModal}
					getList={getAccountList}
				/>
			)}

			{isShowToast && (
				<CustomToastMessage
					icon={checkIcon}
					title={
						selectedAccountId ? 'Account updated successfully' : 'Account created successfully'
					}
					description={
						selectedAccountId
							? 'All changes have been saved and are now reflected in the system.'
							: 'Your account has been created. You can now use it to record and track transactions.'
					}
				/>
			)}

			{isOpenDeleteAccountModal && (
				<DeleteAccountModel
					isOpenModal={isOpenDeleteAccountModal}
					setIsOpenModal={setIsOpenDeleteAccountModal}
					accountId={selectedAccountId}
					getList={getAccountList}
				/>
			)}

			{isOpenDeactivateConfirmAccountModal && (
				<DeactivateConfirmAccountModal
					accountId={selectedAccountId}
					isOpenModal={isOpenDeactivateConfirmAccountModal}
					setIsOpenModal={setIsOpenDeactivateConfirmAccountModal}
					handleDeactivateAccount={handleDeactivateAccount}
				/>
			)}
		</div>
	);
}
